
const translate = text => text;

export default translate;
